import React, { useContext, useEffect, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import RolesContext from '../../contexts/RolesContext';
import AppDivisionContext from '../../contexts/AppDivisionContext';
import AppContext from '../../contexts/AppContext';
import TenantFeatureContext from '../../contexts/TenantContext';
import { shape, string, bool } from 'prop-types';
import {
  faStepBackward,
  faStepForward,
} from '@fortawesome/free-solid-svg-icons';
import { useMediaQuery } from 'react-responsive';
import { ProjectContext } from '../../contexts/ProjectContext';
import { useLogo } from '../../contexts/AppLogoContext';

const Navigation = (props) => {
  const navItems = useContext(RolesContext).getNavItems();
  const appDivisionContext = useContext(AppDivisionContext);
  const appContext = useContext(AppContext);
  const projectContext = useContext(ProjectContext);
  const tenantFeature = useContext(TenantFeatureContext)
  const { panel, setPanel } = appContext;
  const isTabletOrLess = useMediaQuery({ maxWidth: 992 });
  const setDimension = () => ({ width: window.innerWidth });
  const [isWidth, setIsWidth] = useState(isTabletOrLess ? true : false);
  // const [logo, setLogo] = useState(Logo);
  const { appLogo } = useLogo();

  const getDivisionPath = () => {
    const regex = /\/divisions\/(\d+)\/([a-z,-]*)/;

    return props.match.url.match(regex);
  };

  const isDivisionRoute = (path) => {
    const { nonDivisionRoutes } = appContext.get('constants');

    return nonDivisionRoutes && nonDivisionRoutes.includes(path) ? false : true;
  };

  const sidebarToggle = () => {
    if (panel === "open") {
      setPanel("close")
      localStorage.setItem('navigationPanel', "close");
    }
    else {
      setPanel("open")
      localStorage.setItem('navigationPanel', "open");
    }
  };

  const newDimension = () => {
    if (window.innerWidth < 992) {
      setIsWidth(true);
      setDimension({ width: window.innerWidth });
    } else {
      setIsWidth(false);
    }
  };

  const checkSideNavCondition = (navItem) => {
    if (
      (!appDivisionContext.appDivisionId && isDivisionRoute(navItem.route)) ||
      (navItem.name === 'Legend Item' &&
        !tenantFeature.tenantHasFeature('Site Map - Editor Updates')) ||
      (navItem.name === 'Reports' &&
        !(tenantFeature.tenantHasFeature('Compliance Report') ||
          tenantFeature.tenantHasFeature('Findings Report') ||
          tenantFeature.tenantHasFeature('Inspection History Report') ||
          tenantFeature.tenantHasFeature('Missing Inspection Report') ||
          tenantFeature.tenantHasFeature('Project Activity Report')
        )) ||
      (navItem.name === 'Asset Types' &&
        !tenantFeature.tenantHasFeature('Asset Tracking'))
    ) {
      return false;
    }

    return true;
  }

  useEffect(() => {
    window.addEventListener('resize', newDimension);

    return () => {
      window.removeEventListener('resize', newDimension);
    };
  }, []);

  return (
    <nav aria-label='primary side-navigation'>
      {isWidth ? null : (
        <button onClick={sidebarToggle} className='sidebarToggleButton'>
          {panel === 'open' ? (
            <FontAwesomeIcon
              icon={faStepBackward}
              className='sidebarToggleIcon'
            />
          ) : (
            <FontAwesomeIcon
              icon={faStepForward}
              className='sidebarToggleIcon'
            />
          )}
        </button>
      )}

      {props.isHamburger ? (
        <div />
      ) : (
          <div className='nav-logo-holder'>
            <Link to='/dashboard' className='home-link logo-wrapper-link'>
              <img src={appLogo} className='logo pure-img' alt='logo' />
            </Link>
          </div>
      )}

      <ul className={`side-nav ${panel === 'open' ? '' : 'sideNaveShift'}`}>
        {navItems
          .filter((navItem) => {
            return checkSideNavCondition(navItem);  
          })
          .map((navItem) => (
            <li
              key={navItem.name}
              title={panel === 'open' ? '' : navItem.name}
              //disable if offline and name not equal to Project or Dashboard
              style={{
                pointerEvents: !navigator.onLine && navItem.name !== 'Project' && navItem.name !== 'Dashboard' ? 'none' : 'auto',
                opacity: !navigator.onLine && navItem.name !== 'Project' && navItem.name !== 'Dashboard' ? 0.5 : 1,
              }}
            


            >
              <NavLink
                activeClassName='selected'
                to={
                  isDivisionRoute(navItem.route)
                    ? appDivisionContext.getPath(navItem.route)
                    : navItem.route
                }
                isActive={
                  navItem.isActivePath
                    ? () => {
                      let activePath = getDivisionPath();
                      if (activePath && activePath[2] === "areas") activePath = null;
                      return (
                        navItem.isActivePath.indexOf(
                          activePath
                            ? activePath[2]
                            : props.match.path.split('/')[1],
                        ) > -1
                      );
                    }
                    : null
                }
                onClick={(e) => {
                  if(!navigator.onLine && navItem.name !== 'Project' && navItem.name !== 'Dashboard') {
                   e.preventDefault();
                  }
                  projectContext.setFilterProjectPrimaryContact([]);
                  projectContext.setFilterProjectType([]);
                }}
              >
                <FontAwesomeIcon icon={navItem.icon} />

                {panel === 'open' || isWidth ? <span>{navItem.name}</span> : null}
              </NavLink>
            </li>
          ))}
      </ul>
    </nav>
  );
};

Navigation.propTypes = {
  match: shape({
    path: string.isRequired,
  }).isRequired,
  isHamburger: bool,
};

Navigation.defaultProps = {
  isHamburger: false,
};

export default Navigation;
